<template>
  <div>
    <h1 class="title is-4">{{ $t("shopping list") }}</h1>
    <span>{{ products.length }} {{ $t("products") }}</span>
    <br />
    <span class="title is-5 has-text-primary"
      >{{ formatted_total_amount }} {{ $t("total") }}</span
    >

    <div class="buttons is-pulled-right">
      <button
        class="button has-text-primary is-medium"
        :data-tooltip="$t('switch view')"
        :disabled="!products.length"
        @click="switch_view"
      >
        <i class="fa fa-eye"></i>
      </button>
      <button
        class="button has-text-warning is-medium"
        :data-tooltip="$t('clear')"
        :disabled="!products.length"
        @click="products = []"
      >
        <i class="fa fa-eraser"></i>
      </button>
      <button
        class="button has-text-info is-medium"
        :data-tooltip="$t('pay')"
        :disabled="!products.length"
        @click="$emit('pay', { products, total_amount })"
      >
        <i class="fa fa-credit-card"></i>
      </button>
      <!-- <button
        class="button has-text-info is-medium"
        :data-tooltip="$t('charge to account')"
        :disabled="!products.length"
        @click="charge_to_my_account"
      >
        <i class="fa fa-user"></i>
      </button> -->
      <!-- <button
        class="button"
        :data-tooltip="$t('visa payment')"
        :disabled="!products.length"
        @click="visa_pay"
      >
        <i class="fa fa-credit-card"></i>
      </button> -->
    </div>

    <table class="table is-fullwidth" v-if="view == 'long'">
      <thead>
        <tr>
          <th>{{ $t("product") }}</th>
          <th>{{ $t("price") }}</th>
          <th>{{ $t("options") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(product, pidx) in products" :key="pidx">
          <td>{{ product.name }}</td>
          <td>{{ format_currency(product.sale_price) }}</td>
          <td>
            <div
              class="control"
              v-for="(attribute, aidx) in product.attributes"
              :key="aidx"
            >
              <label class="label">{{ attribute.name }}</label>
              <div class="select">
                <select
                  v-model="products[pidx].attributes[aidx].selected_value"
                  v-if="attribute.values"
                >
                  <option value="">{{ $t("select one") }}</option>
                  <option
                    v-for="(value, vidx) in attribute.values.split(',')"
                    :key="vidx"
                  >
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
            <!-- {{ JSON.stringify(product.attributes, null, 2) }} -->
          </td>
          <td>
            <button class="button" @click="products.splice(pidx, 1)">
              <i class="fa fa-trash has-text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table is-fullwidth" v-if="view == 'short'">
      <thead>
        <tr>
          <th>{{ $t("quantity") }}</th>
          <th>{{ $t("product") }}</th>
          <th>{{ $t("options") }}</th>
          <th>{{ $t("total") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(product, pidx) in grouped" :key="pidx">
          <td>{{ product.quantity }}</td>
          <td>{{ product.name }}</td>
          <td>
            <div
              class="control"
              v-for="(attribute, aidx) in product.attributes"
              :key="aidx"
            >
              <label class="label">{{ attribute.name }}</label>
              <div class="select">
                <select
                  @change="
                    attribute_selected_grouped(
                      product.product_id,
                      attribute.name,
                      $event
                    )
                  "
                >
                  <option value="">{{ $t("select one") }}</option>
                  <option
                    v-for="(value, vidx) in attribute.values.split(',')"
                    :key="vidx"
                  >
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
            <!-- {{ JSON.stringify(product.attributes, null, 2) }} -->
          </td>
          <td>{{ format_currency(product.total) }}</td>
          <td>
            <button class="button" @click="remove_product(product)">
              <i class="fa fa-trash has-text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <charge-customer-modal ref="charge_customer_modal" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import { groupBy } from "lodash";
import ChargeCustomerModal from "../../../customer/frontend/charge_account_modal/Index.vue";

export default {
  name: "ShoppingCart",
  components: { ChargeCustomerModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      products: [],
      view: "short",
    };
  },
  methods: {
    format_currency,
    add_product(product) {
      let v = this;
      v.products.push(product);
    },
    clear() {
      let v = this;
      v.products = [];
    },
    switch_view() {
      let v = this;
      if (v.view === "long") v.view = "short";
      else v.view = "long";
    },
    remove_product(product) {
      let v = this;
      let filtered = v.products.filter((p) => {
        return p.product_id != product.product_id;
      });
      v.products = filtered;
    },
    // visa_pay() {
    //   let v = this;
    //   v.$refs.payment_modal.show_modal(v.total_amount);
    // },
    visanet_pay(amount) {
      let v = this;
      // v.$refs.payment_modal.show_modal(amount);
      v.$emit("visanet_payment", amount);
    },
    charge_to_my_account() {
      let v = this;
      v.$refs.charge_customer_modal.show_modal({
        products: v.products,
        total: v.total_amount,
      });
    },
    attribute_selected_grouped(product_id, attribute, event) {
      let v = this;
      let value = event.srcElement.value;
      console.log(product_id, attribute, value);
      v.products = v.products.map((product) => {
        if (product.product_id == product_id) {
          let trgt_attribute = product.attributes.find((att) => {
            return att.name == attribute;
          });
          if (trgt_attribute) trgt_attribute.selected_value = value;
        }
        return product;
      });
    },
  },
  computed: {
    grouped() {
      let v = this;
      let grps = groupBy(v.products, (p) => {
        return p.product_id;
      });
      return Object.keys(grps).map((key) => {
        return {
          product_id: grps[key][0].product_id,
          name: grps[key][0].name,
          quantity: grps[key].length,
          total: grps[key].reduce((acc, product) => {
            return acc + Number(product.sale_price);
          }, 0),
          attributes: grps[key][0].attributes || null,
        };
      });
    },
    total_amount() {
      let v = this;
      return v.products.reduce((acc, product) => {
        return acc + Number(product.sale_price);
      }, 0);
    },
    formatted_total_amount() {
      let v = this;
      let total = v.products.reduce((acc, product) => {
        return acc + Number(product.sale_price);
      }, 0);
      return format_currency(total);
    },
  },
  mounted() {},
};
</script>

<style></style>
